import React from "react";
import { connect } from "react-redux";
import Home from "../../Modules/Home";

const HomeContainer = (props) => <Home {...props} />;

const mapStateToProps = (state) => ({
  home: state.home,
});

export default connect(mapStateToProps, {})(HomeContainer);
